import { createContext, useState } from "react";

export const switchh = createContext();

export default function Switch({children}) {
    const initialReturn = {
        session: false,
        btn: false,
        order: null
    }

    const intialAddWeightManually = {
        data: {},
        status: false
    }

    const [enableDiscount, setEnableDiscount] = useState(false);
    const [enableDelivery, setEnableDelivery] = useState(false);
    const [enableAttendance, setEnableAttendance] = useState(false);
    const [enableAddInInvenotry, setEnableAddInInvenotry] = useState({});
    const [enableSendResetCode, setEnableSendResetCode] = useState(false);
    const [enableReturns, setEnableReturns] = useState(initialReturn);
    const [enableAddWeightManully, setEnableAddWeightManully] = useState(intialAddWeightManually);
    const [access, setAccess] = useState(false);
    const [loadingUser, setLoadingUser] = useState(true);
    const [loadingData,setLoadingData] = useState(false);
    const [loadingProcess, setLoadingProcess] = useState(false);
    const [loadingDebounce, setLoadingDebounce] = useState(false);

    const parent = {
        enableDiscount, 
        setEnableDiscount,
        enableDelivery, 
        setEnableDelivery,
        loadingUser, 
        setLoadingUser,
        loadingData,
        setLoadingData,
        loadingProcess, 
        setLoadingProcess,
        loadingDebounce,
        setLoadingDebounce,
        enableAttendance, 
        setEnableAttendance,
        enableReturns, 
        setEnableReturns,
        initialReturn,
        access, setAccess,
        enableSendResetCode, 
        setEnableSendResetCode,
        enableAddWeightManully, 
        setEnableAddWeightManully,
        intialAddWeightManually,
        enableAddInInvenotry, 
        setEnableAddInInvenotry
    };

    return <switchh.Provider value={parent}>{children}</switchh.Provider>
}